import React from "react";
import MobileInputWrapper from "./style";
import { InputText } from "primereact/inputtext";
import { useSelector } from "react-redux";

const MobileInput = (props) => {
  const { businessLine } = useSelector((state) => state.travel);

  return (
    <MobileInputWrapper dir="ltr">
      {props.withPrefix && (
        <div className={businessLine ? `prefix-${businessLine}` : "prefix"}>
          +966
        </div>
      )}

      <InputText
        name={props.name}
        className={props.className}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        maxLength={9}
      />
    </MobileInputWrapper>
  );
};

export default MobileInput;
